<template>
  <div class="new-element">
    <h2>
      {{ td("components.catalog.newelement.add_element") }}
    </h2>
    <div class="wrapper-content-row">
      <div class="wrapper-content-column">
        <div class="bloc-content-circle set-position-relative">
          <h3>
            {{ td("components.catalog.newelement.element_name") }}
          </h3>
          <input
            v-if="editable == 'name'"
            ref="name"
            type="text"
            v-model="new_element.name"
            class="p"
            @blur="
              editable = '';
              testEmptyContent('name');
            "
          />
          <p
            class="hoverable"
            :data-hover="td('components.catalog.newelement.data_hover.name')"
            v-else
            @click="
              setprevious_content('name');
              editable = 'name';
            "
          >
            {{ new_element.name }}
          </p>
        </div>
        <div class="bloc-content-circle set-position-relative">
          <h3>
            {{ td("components.catalog.newelement.points") }}
          </h3>
          <input
            v-if="editable == 'points'"
            ref="points"
            type="text"
            v-model="new_element.points"
            class="p"
            @blur="
              editable = '';
              testEmptyContent('points');
            "
          />
          <p
            class="hoverable"
            :data-hover="td('components.catalog.newelement.data_hover.points')"
            v-else
            @click="
              setprevious_content('points');
              editable = 'points';
            "
          >
            {{ new_element.points }}
          </p>
        </div>
        <div class="bloc-content-circle set-position-relative">
          <h3>
            {{ td("components.catalog.newelement.photo_mandatory") }}
            <span
              :class="['circle', { clicked: new_element.need_picture == true }]"
              @click.stop="new_element.need_picture = !new_element.need_picture"
            ></span>
          </h3>
        </div>
      </div>
      <div class="wrapper-content-column">
        <div class="bloc-content-circle set-position-relative"></div>
        <div class="bloc-content-circle set-position-relative">
          <h3>
            {{ td("components.catalog.newelement.stars") }}
          </h3>
          <input
            v-if="editable == 'stars'"
            ref="stars"
            type="text"
            v-model="new_element.stars"
            class="p"
            @blur="
              editable = '';
              testEmptyContent('stars');
            "
          />
          <p
            class="hoverable"
            :data-hover="td('components.catalog.newelement.data_hover.stars')"
            v-else
            @click="
              setprevious_content('stars');
              editable = 'stars';
            "
          >
            {{ new_element.stars }}
          </p>
        </div>
        <div class="bloc-content-circle set-position-relative">
          <h3>
            {{ td("components.catalog.newelement.non_declarative") }}
            <span
              :class="[
                'circle',
                { clicked: new_element.undeclarative == true }
              ]"
              @click.stop="
                new_element.undeclarative = !new_element.undeclarative
              "
            ></span>
          </h3>
        </div>
      </div>
    </div>
    <div class="wrapper-content-row">
      <div class="wrapper-content-column container-users">
        <h3 v-if="level == 'ceo_manager'">
          {{ td("components.catalog.newelement.groups_concerned") }}
        </h3>
        <h3 v-if="level == 'group_manager'">
          {{ td("components.catalog.newelement.teams_concerned") }}
        </h3>
        <h3 v-if="level == 'team_manager'">
          {{ td("components.catalog.newelement.sales_concerned") }}
        </h3>
        <div class="wrapper-content-row " v-if="selectedUsers.length > 0">
          <div class="wrapper-content-row container-avatars">
            <div
              class="col-avatar"
              v-for="(item, index) in selectedUsers"
              :key="index"
            >
              <img :src="getProfilPicture(item)" alt="" />
            </div>
          </div>

          <div class="wrapper-content-row container-plus">
            <span
              class="plus-users"
              @click.stop="callback({ type: 'click-plus' })"
              >+</span
            >
          </div>
        </div>
        <div class="wrapper-content-row container-plus" v-else>
          <span
            class="plus-users"
            @click.stop="callback({ type: 'click-plus' })"
            >+</span
          >
        </div>
      </div>
    </div>
    <div class="wrapper-content-row">
      <div class="bloc-content-circle set-position-relative">
        <h3>{{ td("components.catalog.newelement.optional_comment") }}</h3>
        <textarea
          v-if="editable == 'comment'"
          ref="comment"
          type="text"
          v-model="new_element.comment"
          class="p"
          @blur="
            editable = '';
            testEmptyContent('comment');
          "
        ></textarea>
        <p
          class="hoverable"
          :data-hover="td('components.catalog.newelement.data_hover.comment')"
          v-else
          @click="
            setprevious_content('comment');
            editable = 'comment';
          "
        >
          {{ new_element.comment }}
        </p>
      </div>
    </div>
    <div class="wrapper-content-row container-buttons">
      <div class="bloc-periodes-footer">
        <button class="" @click.stop="saveElement()">
          {{ td("components.alertbox.valide_cta.valide") }}
        </button>
        <button class="negatif" @click.stop="callback({ type: 'cancel' })">
          {{ td("components.catalog.update_element.cta.cancel") }}
        </button>
      </div>
    </div>
    <transition name="fade">
      <div
        class="container-alert"
        style="height:100%"
        v-if="show_alert_box === true"
      >
        <alertBox
          :msg="msg_alert"
          :callback="alertCallback"
          :delay="alert_delay"
        />
      </div>
    </transition>
  </div>
</template>
<script>
/* eslint-disable no-unused-vars */
import axios from "axios";
import { td } from "../../traductions/traductionsHelpers";
import alertBox from "./../alertBoxes/alertBox";
export default {
  name: "NewElement",
  components: { alertBox },
  props: [
    "callback",
    "level",
    "selectedUsers",
    "group_token",
    "team_token",
    "creator_token"
  ],
  data: () => {
    return {
      editable: "",

      //alert box
      show_alert_box: false,
      msg_alert: td("components.catalog.newelement.msg_alert"),
      alert_delay: 3000,
      admin_levels: {},
      user: {},
      admin_level: "",
      circle: {},
      previous_content: {
        new_element: {}
      },
      new_element_init: {
        name: td("components.catalog.newelement.new_element_init.name"),
        comment: td("components.catalog.newelement.new_element_init.comment"),
        points: 0,
        stars: 0,
        need_picture: false,
        undeclarative: false
      },
      new_element: {}
    };
  },
  methods: {
    td,
    alertCallback(obj) {
      if (obj.type == "end_delay") {
        this.show_alert_box = false;
      }
    },
    getProfilPicture(item) {
      let url = "/assets/img/profil.png";
      if (item.picture.trim() == "") {
        url = "/assets/img/profil.png";
      } else {
        url = axios.defaults.baseURL + "/images/" + item.picture;
      }
      return url;
    },
    setprevious_content(key) {
      this.previous_content.new_element[key] = this.new_element[key];
      if (this.new_element[key] == this.new_element_init[key]) {
        this.new_element[key] = "";
      }
      setTimeout(() => {
        if (this.$refs[key]) {
          this.$refs[key].focus();
        }
      }, 250);
    },
    testEmptyContent(key) {
      if (this.new_element[key].trim() == "") {
        this.new_element[key] = this.previous_content.new_element[key];
      }
    },
    saveElement() {
      let element = { ...this.new_element };
      if (element.name == this.new_element_init.name) {
        this.msg_alert = td("components.catalog.save_element.name_msg_alert"); //"Vous devez donner un nom à votre élément";
        this.show_alert_box = true;
        return;
      }
      if (element.points == 0 && element.stars == 0) {
        this.msg_alert = td("components.catalog.save_element.stars_msg_alert"); //"Vous devez donner des points ou des étoiles à votre élément";
        //this.show_alert_box = true;
        //return;
      }
      if (element.comment == this.new_element_init.comment) {
        element.comment = "";
      }
      element.level = this.level;
      element.selected_users = this.selectedUsers;
      element.selected_user_tokens = [];
      element.owner_token = this.user.user_token;
      element.owner_data = this.user;
      element.circle_token = this.circle.circle_token;
      element.group_token = this.group_token;
      element.team_token = this.team_token;
      element.creator_token = this.creator_token;

      let context = this;
      let store = this.$store;
      let router = this.$router;
      context;
      router;
      store;
      let credentials = {};
      if (this.$store.getters.isConnected) {
        credentials = this.$store.getters.credentials;
      }

      let filters = {
        circle_token: this.circle.circle_token,
        group_token: this.group_token,
        team_token: this.team_token,
        level: this.level
      };

      //return;

      // eslint-disable-next-line no-unreachable
      let sendData = { credentials, element, filters };

      axios
        .post("/elements/new", sendData)
        .then(function(result) {
          let data = result.data;

          if (data.response.success === true) {
            const authData = {
              tokenId: data.tokenId,
              userToken: data.user_context.user.user_token,
              userData: data.user_context.user
            };

            store.commit("authUser", authData);
            context.msg_alert = "L'élément a été enregistré";
            context.show_alert_box = true;
            context.new_element = JSON.parse(
              JSON.stringify(context.new_element_init)
            );

            context.callback({ type: "element-saved" });
          } else {
            store.dispatch("logout");
            router.replace("/login");
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  },
  mounted() {
    this.user = this.$store.state.userData;
    this.admin_level = this.user.admin_level;
    this.admin_levels = this.$store.state.admin_levels;
    this.circle = this.$store.state.circleData;
    this.new_element = JSON.parse(JSON.stringify(this.new_element_init));
  }
};
</script>
